export default function AttachPreparationItemDialogController(
  $q,
  $filter,
  ssDialogService,
  loaderService,
  amDataService,
  docDataService
) {
  const vm = this;

  vm.handleExpandFolder = _handleExpandFolder;
  vm.handleCloseDialog = _handleCloseDialog;

  _activate();

  /** **********************************************
   * Event Handlers
   */

  function _handleExpandFolder() {
    vm.isDocumentsExpanded = !vm.isDocumentsExpanded;
    if (vm.isDocumentsExpanded) {
      _refreshFolder();
    }
  }

  function _handleCloseDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.auditTrail.attachDocumentDialog);
  }

  /** **********************************************
   * Private Functions
   */

  function _activate() {
    vm.canExpand = vm.status !== 'No Folder Added';
    vm.isDocumentsExpanded = true;
    vm.isReportsExpanded = true;
    vm.itemsLoaded = false;

    return $q.all([
      docDataService.getCustomerReportInstances(),
      _refreshFolder(),
    ]).then((results) => {
      loaderService.showViewLoader = false;
      vm.reportFolders = results[0].data;
      vm.itemsLoaded = true;
    });
  }

  function _refreshFolder() {
    const dfdRefresh = $q.defer();

    docDataService.getChildItemList(vm.serviceId, vm.folder.documentId).then((response) => {
      vm.folder.childDocuments = $filter('filter')(response.data.ChildDocuments, { documentTypeId: 0 });
      vm.folder.childFolders = $filter('filter')(response.data.ChildDocuments, { documentTypeId: 1 });

      $q.all([
        _updateChildDocuments(),
        _updateChildFolders(),
      ]).then(() => {
        dfdRefresh.resolve();
      });
    });

    return dfdRefresh.promise;
  }

  function _updateChildDocuments() {
    const dfdUpdate = $q.defer();
    if (vm.folder.childDocuments.length > 0) {
      amDataService.getPreparationItemDocumentsByFolder(vm.folder.documentId).then((response) => {
        const assignedDocs = response.data.result;
        if (assignedDocs.length > 0) {
          assignedDocs.forEach((assignedDoc) => {
            vm.folder.childDocuments.forEach((childDoc) => {
              if (childDoc.documentId === assignedDoc.documentId
                && assignedDoc.preparationItemId === vm.preparationItemId) {
                childDoc.preparationItemDocumentId = assignedDoc.preparationItemDocumentId;
                childDoc.attached = true;
              }
            });
          });
        }
        dfdUpdate.resolve();
      });
    } else {
      dfdUpdate.resolve();
    }
    return dfdUpdate.promise;
  }

  function _updateChildFolders() {
    const dfdUpdate = $q.defer();
    if (vm.folder.childFolders.length > 0) {
      amDataService.getPreparationItemFoldersByFolder(vm.folder.documentId).then((response) => {
        const assignedFolders = response.data.result;
        if (assignedFolders.length > 0) {
          assignedFolders.forEach((assignedFolder) => {
            vm.folder.childFolders.forEach((childFolder) => {
              if (childFolder.documentId === assignedFolder.folderId
                && assignedFolder.preparationItemId === vm.preparationItemId) {
                childFolder.preparationItemFolderId = assignedFolder.preparationItemFolderId;
                childFolder.attached = true;
              }
            });
          });
        }
        dfdUpdate.resolve();
      });
    } else {
      dfdUpdate.resolve();
    }
    return dfdUpdate.promise;
  }
}

AttachPreparationItemDialogController.$inject = [
  '$q',
  '$filter',
  'ssDialogService',
  'loaderService',
  'amDataService',
  'docDataService'
];
